import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicSwathNoDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismicswathno-container',
  templateUrl: './seismicswathno-container.component.html',
  styleUrls: ['./seismicswathno-container.component.scss']
})
export class SeismicSwathNoContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismicswathnos$: Observable<SeismicSwathNoDto[]>;
  loading: boolean;
  isLoadingSeismicSwathNo$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingSeismicSwathNo$ = this.gatwayFacade.isLoadingGateway("SeismicSwathNo");
    this.seismicswathnos$ = this.gatwayFacade.loadGateway("SeismicSwathNo");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicSwathNo(deletedValue: any) {
    this.gatwayFacade.remove("SeismicSwathNo", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicSwathNo(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicSwathNos;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicSwathNo = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id != null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicSwathNo.push(pullData[i]);
    }
  }

// check if the addAllSeismicSwathNo array is not empty, then dispatch the data to the store
   if(addAllSeismicSwathNo.length > 0) {
    this.gatwayFacade.add('SeismicSwathNo', addAllSeismicSwathNo);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicSwathNo', allUpdates, ['id']);
  }

   }


}
